import { connect } from 'react-redux'
import {
  updateOrderData,
  updateOrderedProductPricelistItem,
  updateOrderedProductOrderField,
  updateOrderCustomerParticipant,
  calculateOrderPricing,
  validateCustomerForm,
  submitCustomerForm
} from '../actions'
import orderSelector from '../selectors/orderSelector'
import ProductOrderFieldsFormSection from '../components/ProductOrderFieldsFormSection'
import RulesAgreement from '../components/RulesAgreement'
import PersonalDataAgreement from '../components/PersonalDataAgreement'
import RodoAgreement from '../components/RodoAgreement'
import PartnersAgreement from '../components/PartnersAgreement'

const mapStateToProps = (state) => {
  return {
    order: orderSelector(state),
    errors: state.errors,
    isSaveOrderLoading: state.isSaveOrderLoading
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrderData: data => dispatch(updateOrderData(data)),
    updateOrderedProductPricelistItem: (...args) => dispatch(updateOrderedProductPricelistItem(...args)),
    updateOrderedProductOrderField: (...args) => dispatch(updateOrderedProductOrderField(...args)),
    updateOrderCustomerParticipant: (...args) => dispatch(updateOrderCustomerParticipant(...args)),
    calculatePricing: _.throttle(() => dispatch(calculateOrderPricing()), 500),
    validateForm: () => dispatch(validateCustomerForm()),
    submitForm: () => dispatch(submitCustomerForm()),
  }
}

class NewOrderCustomerDetailsForm extends React.Component {
  componentDidMount() {
    const container = ReactDOM.findDOMNode(this);

    $(container).find(".js-pikaday-field").each((i, fieldElement) =>
      new Pikaday({
        field: fieldElement,
        maxDate: new Date(),
        format: moment.RUBY_DATE_FORMAT
      })
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();
    this.props.submitForm().then(() => {
      this.props.onSave();
    });
  }

  handleChange(attribute, event) {
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;

    this.props.updateOrderData({
      [attribute]: value
    });

    this._triggerFormUpdate();
  }

  handleOrderedProductOrderFieldValueChange(parent, orderedField, value) {
    this.props.updateOrderedProductOrderField(parent, orderedField, value)
    this._triggerFormUpdate();
  }

  renderBaseErrors() {
    const baseErrors = _(this.props.errors)
      .values()
      .flatten()
      .value();

    return baseErrors.length > 0 && (
      <div className="alert alert-danger">
        {baseErrors.map((error, i) => <p key={i}>{error}</p>)}
      </div>
    )
  }

  renderFormFieldErrors(fieldName) {
    const errors = this.props.errors[fieldName];

    return errors && errors.length > 0 && (
      <div className="form-error">{errors.map((error, i) => <p key={i}>{error}</p>)}</div>
    );
  }

  render() {
    const submitButtonText = (this.props.order.data.confirmation_installment_without_company_approval || this.props.order.data.confirmation_installment_before_company_approval)
      ? I18n.t("fe.NewOrderCustomerDetailsForm.submit.next")
      : I18n.t("fe.NewOrderCustomerDetailsForm.submit.make_order");

    // This is left here to show how to render form errors for a formrow
    // <div className={classNames("form-group form-group-xxs-fullwidth", {
    //   "has-error": this.props.errors.customer_first_name && this.props.errors.customer_first_name.length > 0
    // })}>
    //   <div className="form-label">
    //     <label className="control-label" htmlFor="new-order-customer-details-form-customer_first_name">
    //       {I18n.t("attributes.first_name")} *
    //     </label>
    //   </div>
    //   <div className="form-wrapper">
    //     <input
    //       type="text"
    //       id="new-order-customer-details-form-customer_first_name"
    //       className="form-control"
    //       value={this.props.order.data.customer_first_name || ""}
    //       onChange={this.handleChange.bind(this, "customer_first_name")} />
    //
    //     {this.renderFormFieldErrors("customer_first_name")}
    //   </div>
    // </div>

    return (
      <form onSubmit={this.handleFormSubmit.bind(this)} className="form form-horizontal new-order-customer-details-form">
        {this.renderBaseErrors()}

        <ProductOrderFieldsFormSection
          order={this.props.order.data}
          handleOrderedFieldValueChange={this.handleOrderedProductOrderFieldValueChange.bind(this)}
          />

        {this.props.order.requiresCustomerRulesAgreement &&
          <RulesAgreement
            order={this.props.order}
            checked={!!this.props.order.data.rules_agreement}
            onChange={this.handleChange.bind(this, "rules_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <PersonalDataAgreement
            checked={!!this.props.order.data.personal_data_agreement}
            onChange={this.handleChange.bind(this, "personal_data_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <RodoAgreement
            checked={!!this.props.order.data.rodo_agreement}
            onChange={this.handleChange.bind(this, "rodo_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <PartnersAgreement
            checked={!!this.props.order.data.partners_agreement}
            onChange={this.handleChange.bind(this, "partners_agreement")} />}

        <div className="form-group form-group-xxs-fullwidth">
          <div className="form-label form-legend">
            <div className="help">
              * - {I18n.t("fe.NewOrderCustomerDetailsForm.required_fields")}
            </div>
          </div>
          <div className="form-wrapper order-description-button-sticky">
            <button
              type="submit"
              className="btn btn-lg btn-primary"
              disabled={this.props.isSaveOrderLoading}
              onClick={this.handleFormSubmit.bind(this)}>
              {!this.props.isSaveOrderLoading && submitButtonText}
              {!!this.props.isSaveOrderLoading && <i className="fa fa-spin fa-circle-o-notch"></i>}
            </button>
          </div>
        </div>

        {this.props.order.data.has_pricing && !this.props.order.data.confirmation_installment_without_company_approval && !this.props.order.data.confirmation_installment_before_company_approval && (
          <div className="new-order-form-rules-footer">
            ({I18n.t("fe.NewOrderCustomerDetailsForm.order_with_payment_requirement")})
          </div>
        )}
      </form>
    );
  }

  _triggerFormUpdate() {
    // this.props.order.clearValidation();
    // this.props.validateForm();
  }
}

const ConnectedNewOrderCustomerDetailsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewOrderCustomerDetailsForm)

export default ConnectedNewOrderCustomerDetailsForm



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/NewOrderCustomerDetailsForm.jsx